<div class="card p-6!" *transloco="let t; prefix: 'wizard.project'">
  <p-fluid>
    <div class="flex flex-col gap-6">
      <h2 data-testid="company-step-title" class="text-xl font-semibold mb-6">
        {{ t('addCompany') }}
      </h2>

      <div
        class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4"
        data-testid="companies-list"
      >
        @for (company of companies; track $index) {
          <div class="flex items-center gap-2">
            <p-checkbox
              [id]="'company-' + $index"
              [binary]="true"
              [ngModel]="isCompanySelected(company.id)"
              (onChange)="toggleCompany(company.id)"
              [attr.data-testid]="'company-' + company.id"
            />
            <label [for]="'company-' + company.id">
              {{ company.name }}
            </label>
          </div>
        }
      </div>
    </div>
  </p-fluid>
</div>
